module.exports = __webpack_public_path__ + "img/m-banner-kfkmkuef-de-DE.ecb06bfd.png";